import React, { lazy, Suspense } from 'react';

const PowerUpDirectory = lazy(() =>
  import(/* webpackChunkName: "power-up-directory" */ './PowerUpDirectory'),
);

export const LazyPowerUpDirectory: React.FunctionComponent<{
  section?: string;
  subsection?: string;
  query?: string;
  billingUrl?: string;
}> = ({ section, subsection, query, billingUrl }) => {
  return (
    <Suspense fallback={null}>
      <PowerUpDirectory
        section={section}
        subsection={subsection}
        query={query}
        billingUrl={billingUrl}
      />
    </Suspense>
  );
};
